// extracted by mini-css-extract-plugin
export default {"comeBack":"ComeBackButton_comeBack__Hz+rp","comeBack__arrow":"ComeBackButton_comeBack__arrow__htMpy"};